export default __webpack_public_path__ + "static/media/navbar-managers-dark.a759c30c.svg";